import { createFileRoute, redirect } from "@tanstack/react-router";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";
import { SubscriptionSuccess } from "../../../features/subscriptions/routes/success";

const Route = createFileRoute("/_authorized/subscription_/success/")({
  beforeLoad: ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["SUBSCRIPTION_VIEW", "SUBSCRIPTION_EDIT"]);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <SubscriptionSuccess />,
});

export { Route };
